import { useState } from "react";
import { Grid } from "@material-ui/core";

// Components
import ResetPasswordForm from "./ResetPasswordForm";

const ResetPassword = () => {
	const [error, setError] = useState(null);
	const [message, setMessage] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	return (
		<Grid>
			<ResetPasswordForm
				isLoading={isLoading}
				setIsLoading={setIsLoading}
				error={error}
				setError={setError}
				message={message}
				setMessage={setMessage}
			/>
		</Grid>
	);
};

export default ResetPassword;
